<template>
    <ui-data-table 
        :p-headers="headers"
        p-title="Mesas"
        p-read-link="table.read.one"
        p-create-link="table.create"
        p-name="tables"
    />
</template>
<script>

import {uiDataTable} from '@/components/ui'
export default {
    name: 'vwTableRead',
    components: {
        uiDataTable  
    },
    data(){
        return {
            headers: [{
                text: 'id',
                value: 'id'
            }, {
                text: 'status',
                value: 'status'
            }, {
                text: 'Cadastrado',
                value: 'criado_em'
            }, {
                text: 'Ações', 
                value: 'actions', 
                sortable: false
            }],
        }
    },
}
</script>